import React from 'react'
import { PositionType } from '../type/PositionType'

export const handleGeocoder = (
    lat: number,
    lng: number,
    defaultLat: number,
    defaultLng: number,
    setPosition: (position: PositionType) => void,
    setGeolocation: React.Dispatch<
        React.SetStateAction<google.maps.LatLngLiteral | undefined>
    >
) => {
    // Defensive early return and fallback if Google Maps API is not fully loaded
    if (
        typeof google === 'undefined' ||
        !google.maps ||
        !google.maps.Geocoder
    ) {
        setGeolocation({ lat, lng })
        return
    }

    const geocoder = new google.maps.Geocoder()

    geocoder
        .geocode({ location: { lat, lng } })
        .then((response) => {
            let localePosition = {
                lat: defaultLat,
                lng: defaultLng,
            }

            if (response.results[0] && response.results[0].formatted_address) {
                const address = response.results[0].formatted_address
                if (address.includes('Praha')) {
                    localePosition = { lat, lng }
                    // User is in Praha – mark their geolocation dot on the map
                    setGeolocation({ lat, lng })
                }
            } else {
                console.log('Geocoder returned no result')
            }
            setPosition(localePosition)
        })
        .catch((e) => {
            console.log(`Geocoder caught an error: ${e}`)
            setPosition({
                lat: defaultLat,
                lng: defaultLng,
            })
        })
}
